/* Filter chips for the collection toolbar.
   A chip opens its option strip under the bar; one strip at a time; click
   outside or Escape closes. Uses event delegation on document because the
   theme replaces the whole collection section after every filter change. */
(function () {
  function closeAll(except) {
    document.querySelectorAll('[data-iv-strip]').forEach(function (strip) {
      if (strip !== except) strip.hidden = true;
    });
    document.querySelectorAll('[data-iv-chip]').forEach(function (chip) {
      if (!except || chip.getAttribute('aria-controls') !== except.id) {
        chip.setAttribute('aria-expanded', 'false');
        chip.classList.remove('is-open');
      }
    });
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-iv-chip]');
    if (chip) {
      var strip = document.getElementById(chip.getAttribute('aria-controls'));
      if (!strip) return;
      var open = !strip.hidden;
      closeAll(open ? null : strip);
      strip.hidden = open;
      chip.setAttribute('aria-expanded', open ? 'false' : 'true');
      chip.classList.toggle('is-open', !open);
      return;
    }
    if (!e.target.closest('.iv-toolbar')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* Mayave opens a filter strip on hover, not click. Pointer devices only:
     a touch "hover" would open a strip the tap then immediately closes, so
     this is gated on a real hover-capable pointer. A small close delay keeps
     the strip open while the pointer travels from the chip down to it. */
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (canHover) {
    var closeTimer = null;

    function cancelClose() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }

    function scheduleClose() {
      cancelClose();
      closeTimer = setTimeout(closeAll, 220);
    }

    document.addEventListener('mouseover', function (e) {
      var chip = e.target.closest('[data-iv-chip]');
      if (chip) {
        cancelClose();
        var strip = document.getElementById(chip.getAttribute('aria-controls'));
        if (!strip || !strip.hidden) return;
        closeAll(strip);
        strip.hidden = false;
        chip.setAttribute('aria-expanded', 'true');
        chip.classList.add('is-open');
        return;
      }
      if (e.target.closest('[data-iv-strip]')) cancelClose();
    });

    document.addEventListener('mouseout', function (e) {
      if (e.target.closest('[data-iv-chip]') || e.target.closest('[data-iv-strip]')) scheduleClose();
    });
  }
})();
